import { ASTFragment } from "../fragment";
import { ASTNode } from "../nodes/ast-node";
import { Cursor } from "@tab-edit/model";

// TODO: Change this to ASTNodeCursor that takes in a nodeset in the constructor
export class ASTFragmentCursor implements Cursor<ASTNode> {
    private ancestryTrace: number[] = [];
    private pointer: number = 0;

    constructor(readonly fragment: ASTFragment) {}
    get name() { return this.fragment.nodeSet[this.pointer].name }
    get node() { 
        return new ASTNode(this.fragment.nodeSet[this.pointer], this);
    }

    getAncestors() {
        return this.ancestryTrace.map(pos => new ASTNode(this.fragment.nodeSet[pos], this));
    }

    firstChild() {
        if (this.fragment.nodeSet.length===0) return false;
        let currentPointer = this.pointer;
        if (this.fragment.nodeSet[this.pointer].descendantCount===0) return false;
        this.pointer+=1;
        this.ancestryTrace.push(currentPointer);
        return true;
    }

    lastChild() {
        if (!this.firstChild()) return false;
        while (this.nextSibling()) {}
        return true;
    }

    parent() {
        if (this.fragment.nodeSet.length===0 || this.ancestryTrace.length===0) return false;
        this.pointer = this.ancestryTrace[this.ancestryTrace.length-1];
        this.ancestryTrace.pop();
        return true;
    }

    prevSibling() {
        let currentPointer = this.pointer;
        if (!this.parent()) return false;

        this.firstChild();
        let prevSiblingPointer = this.pointer;
        if (prevSiblingPointer===currentPointer) return false;

        while (this.nextSibling() && this.pointer!==currentPointer) {
            prevSiblingPointer = this.pointer;
        }
        this.pointer = prevSiblingPointer;
        return true;
    }

    nextSibling() {
        if (!this.ancestryTrace.length) return false
        let parentPointer = this.ancestryTrace[this.ancestryTrace.length-1];

        let nextInorder = this.pointer + this.fragment.nodeSet[this.pointer].descendantCount + 1;
        if (parentPointer + this.fragment.nodeSet[parentPointer].descendantCount + 1 <= nextInorder) return false;
        this.pointer = nextInorder;
        return true;
    }

    fork() {
        const copy = new ASTFragmentCursor(this.fragment);
        copy.pointer = this.pointer;
        copy.ancestryTrace = this.ancestryTrace;
        return copy;
    }

    // TODO: deprecate
    static get dud() { return new ASTFragmentCursor(ASTFragment.createBlankFragment(0,0)); }

    printTree() {
        let str = this.printTreeRecursiveHelper();
        return str;
    }
    private printTreeRecursiveHelper() {
        if (this.fragment.nodeSet.length==0) return "";
        let str = `${this.fragment.nodeSet[this.pointer].name}`;
        if (this.firstChild()) str += "(";
        else return str;
        let first = true;
        do {
            if (!first) str += ",";
            first = false;
            str += this.printTreeRecursiveHelper();
        } while (this.nextSibling());
        str += ")";
        this.parent();
        return str;
    }
}